"use client";
import pusher from "../pusher.js";
export const subscribeToPusherChannel = (channelName) => {
    if (!channelName) {
        return null;
    }
    return pusher.subscribe(channelName);
};
export const usePusherUserChannel = (userId) => {
    return subscribeToPusherChannel(userId ? `clerk-user-${userId}` : null);
};
export const usePusherOrgChannel = (orgId) => {
    return subscribeToPusherChannel(orgId ? `clerk-org-${orgId}` : null);
};
export const usePusherFileChannel = (fileId) => {
    return subscribeToPusherChannel(fileId ? `file-${fileId}` : null);
};
/**
 * Channel for a public/anonymous visitor's analysis events. Matches the backend
 * convention `anonymous-client-{id}` used for the no-login analysis flow.
 */
export const usePusherAnonymousChannel = (anonymousClientId) => {
    return subscribeToPusherChannel(anonymousClientId ? `anonymous-client-${anonymousClientId}` : null);
};
